module.exports = __webpack_public_path__ + "img/pic_04.08e61fc4.png";